import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import { RadioButtonGroup } from '@els/els-react--radio-button';
import { Checkbox } from '@els/els-react--checkbox';

import './CheckRadio.scss';

function CheckRadio({ option, value, onChange = noop }) {
  const handleCheckboxChange = (event) => {
    const { checked } = event.target;
    if (option.subOptions) {
      const newValue = checked ? option.subOptions[0].value : '';
      onChange(newValue);
    } else {
      onChange(checked);
    }
  };

  return (
    <div className="profile-settings-checkradio">
      <Checkbox
        data-e2e={`profile-settings-checkradio-${option.id || option.label || 'option'}`}
        label={option.label}
        onChange={handleCheckboxChange}
        checked={!!value}
        id={option.id}
      />
      {option.type === 'check_radio' && (
        <div className="profile-settings-checkradio__fragments">
          <fieldset className="profile-settings-checkradio__fieldset">
            <legend className="sr-only">{option.label || 'Radio options'}</legend>
            <ul className="rx-radio_button-group rx-radio_button-group--left">
              {option.subOptions &&
                option.subOptions?.map((suboption) => (
                  <li className="u-els-margin-bottom-1o2" key={suboption.value}>
                    <RadioButtonGroup.Option
                      id={`radio-button-${suboption.value}`}
                      name={`${option.id}-radio`}
                      label={suboption.label}
                      className="unchecked-appearance-on-disable"
                      checked={!!value && value === suboption.value}
                      value={suboption.value}
                      onChange={() => {
                        onChange(suboption.value);
                      }}
                      disabled={!value}
                    />
                  </li>
                ))}
            </ul>
          </fieldset>
        </div>
      )}
    </div>
  );
}

CheckRadio.propTypes = {
  option: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.bool, PropTypes.string]),
  onChange: PropTypes.func,
};

export default CheckRadio;
